module.exports = __webpack_public_path__ + "img/logotipo_green_10.0222be8f.png";